// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__27CFv","title":"Images45_title__lPwl4","images":"Images45_images__hfuLI"};